( function () {
   
    'use strict';

    ( function ( $ ) {
      
		//start the slider
		   
        $(".get-list").click(function () {
            if ($(this).hasClass('active')) {
            } else {
              var tabid = $(this).attr('id');
              $(".get-list").removeClass('active');
              $(this).addClass('active');
              $(".get-list-content").removeClass('active');
              $("#" + tabid + "-content").addClass("active");
            }
            return false;
        });
        $('.get-ticket-slider').slick({
          dots:false,
          infinite: false,
          speed: 600,
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '120px',
          autoplay:false,
          autoplaySpeed: 2000,
          arrows:true,
          responsive: [
            {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 1,
                  centerPadding: '20px',
                }
            },
            {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  centerPadding: '0px',
                }
            },
           
            ]
      });

      
    //   .on("setPosition", function () {
    //     resizeSlider();
    //   });
    
    // $(window).on("resize", function (e) {
    //   resizeSlider();
    // });
    
    // var slickHeight = $(".slick-track").outerHeight();
    
    // var slideHeight = $(".slick-track").find(".slick-slide").outerHeight();
    
    // function resizeSlider() {
    //   $(".slick-track")
    //     .find(".slick-slide .get-tickets-box .get-tickets-box-inner")
    //     .css("height", slickHeight + "px");
    // }
      
    } )(jQuery);
} )();

